export default class FlashNotice {
  constructor(rootNode) {
    this.$refs = {
      rootNode,
      actionBtn: rootNode.querySelector('.action'),
    };

    this.$refs.rootNode.classList.add('is-visible');

    this.setupHandlers();
  }

  setupHandlers() {
    this.$refs.actionBtn.addEventListener('click', () => this.hide());

    setTimeout(() => this.hide(), 2000);
  }

  hide() {
    this.$refs.rootNode.classList.remove('is-visible');
  }
}
